<template>
	<div id="bottom">
		<div class="cc-header">班级评价统计信息</div>
		<dv-scroll-board :config="config" class="leavelist" />
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgId = storage.getItem("orgId");
	export default {
		data() {
			return {
				config: {}
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，1小时
			let _this = this;
			setInterval(() => {
				_this.initData(); // 修改数据date
			}, 1000 * 60 * 60);
		},
		methods: {
			initData() {
				let _this = this;
				this.$http.get("/dataView/headmaster/clazzEvaluate?orgId=" + orgId).then(res => {
					if (res.data.code === 200) {
						var typeList = ['班级'];
						var alignList = ['center','center','center'];
						for (let i = 0; i < res.data.typeList.length; i++) {
							typeList.push(res.data.typeList[i].typeName);
							alignList.push('center');
						}
						typeList.push('评价教师','评价时间');
						var dataList = [];
						for (let i = 0; i < res.data.dataList.length; i++) {
							var child = [res.data.dataList[i].clazzName];
							var childList = res.data.dataList[i].childList;
							for (let k = 0; k < childList.length; k++) {
								if(childList[k].flowerCount == 0){
									child.push('<div class="rank_img"><img width="100%" src="'+require("../../assets/img/star_00.png")+'"></div>');
								}else if(childList[k].flowerCount == 1){
									child.push('<div class="rank_img"><img width="100%" src="'+require("../../assets/img/star_01.png")+'"></div>');
								}else if(childList[k].flowerCount == 2){
									child.push('<div class="rank_img"><img width="100%" src="'+require("../../assets/img/star_02.png")+'"></div>');
								}else if(childList[k].flowerCount == 3){
									child.push('<div class="rank_img"><img width="100%" src="'+require("../../assets/img/star_03.png")+'"></div>');
								}else if(childList[k].flowerCount == 4){
									child.push('<div class="rank_img"><img width="100%" src="'+require("../../assets/img/star_04.png")+'"></div>');
								}else if(childList[k].flowerCount == 5){
									child.push('<div class="rank_img"><img width="100%" src="'+require("../../assets/img/star_05.png")+'"></div>');
								}
							}
							child.push(res.data.dataList[i].teacherName);
							child.push(res.data.dataList[i].checkTime);
							dataList.push(child);
						}
						if(res.data.typeList.length > 0){
							_this.config = {
								header: typeList,
								data: dataList,
								headerBGC: '',
								oddRowBGC: 'none',
								evenRowBGC: 'none',
								headerHeight: 30,
								rowNum: 3, //表格行数
								waitTime: 2000,
								align: alignList
							};
						}else{
							_this.config = {
								data: [['<div class="noneData">暂未设置评价指标</div>']],
								evenRowBGC: 'none',
								rowNum: 1,
								align: ['center']
							};
						}
					}
				});
			}
		}
	};
</script>

<style lang="scss">
	#bottom {
		height: 100%;

		.leavelist {
			padding: 0.15rem 2%;
			width: 100%;
			height: 75%;
		}

		.leavelist .header {
			background: url("../../assets/img/hm_tblbg.png") center repeat-y;
			background-size: 100%;
			color: #00f0ff;
			font-size: 0.2rem;
			font-weight: bold;
		}

		.leavelist .row-item {
			background: url("../../assets/img/hm_tblbg.png") bottom no-repeat;
			background-size: 100%;
			color: #fff;
			font-size: 0.2rem;
		}

		// .row-item .rank_img {
		// 	display: flex;
		// 	align-items: center;
		// 	line-height: inherit;
		// }

		.row-item .rank_img img {
			width: 1.5rem;
			height: 0.3rem;
			vertical-align: sub;
		}
	}
</style>
